const content: { [key: string]: any } = {
  pageTitle: "Strong Start Incentive+ Upline Report",
  tabs: {
    inGracePeriod: {
      label: "In Grace Period",
      desc: "The ABOs listed below are currently within their Grace Period for the Strong Start Incentive+, which is based on a three-month window starting from their registration month. ABOs in the last chance list are on their final opportunity to qualify for the Strong Start Incentive+ and must meet the requirements to enter their qualification window. The next two lists show ABOs in their registration month and the previous month, highlighting their progress toward entering the Strong Start Incentive+ program.",
    },
    inSSIProgram: {
      label: "In SSI Program",
      desc: "This report shows ABOs in their SSI tracking window. The top section lists those eligible for payout if this month’s requirements are met. The bottom section shows overall progress, including Program Start Date and requirements.",
    },
    outOfSSIProgram: {
      label: "Out of SSI Program",
      desc: "The ABOs listed below are no longer in the Strong Start Incentive+ program.",
    },
    earnedPayment: {
      label: "Earned a Payment",
      desc: "The ABOs listed below have earned a payment in the last 12 months.",
    },
  },
  donutChart: {
    ppv: "PPV",
    vcs: "VCS",
    ppvDesc: "<1>{currentAmount}</1>/<1>{targetAmount}</1>",
    vcsDesc: "<1>{currentAmount}%</1>/{targetAmount}%",
  },
  monthEntry: "{month} Entry ({abos})",
  sponsor: "Sponsor",
  profile: "Profile",
  lastChance: "Last Chance",
  confidentialUser: "Confidential User",
  searchPlaceholder: "Search by name or ID number",
  clearSearch: "Clear Search",
  export: "Export",
  inSSIProgram: {
    inPaymentMonth: "In Payment Month",
    inSSIProgram: "In SSI Program",
    columns: {
      aboNameNum: "ABO Name / Number",
      programStartDate: "Program Start Date",
      monthsQualified: "Months Qualified",
      paymentsReceived: "Payments Received",
      sponsor: "Sponsor",
      monthsInProgram: "Months In Program",
    },
  },
  earnedPayment: {
    columns: {
      aboNameNum: "ABO Name / Number",
      programStartDate: "Program Start Date",
      paymentMonth: "Payment Month",
      sponsor: "Sponsor",
    },
    paymentsReceived: "Payments Received",
    paymentReceived: "Payment Received",
  },
  profileModal: {
    title: "ABO Profile",
    abo: "ABO",
    mobileNumber: "Mobile Number",
    emailAddress: "Email Address",
    sponsor: "Sponsor",
    eligibilityDescription:
      "You must achieve the requirements <strong>every month</strong> in order to continue in the Strong Start Incentive+.",
  },
};

export default content;
